import { Action } from '@ngrx/store';

import { StorelocationInformation } from './StorelocationInformation.model';

export const ADD_STORE_INFORMATION = 'Select Store Location';

export class AddStorelocationInformation implements Action {
    readonly type = ADD_STORE_INFORMATION;

    constructor(public payload: StorelocationInformation) { }
}


export type StoreInformationActions =    | AddStorelocationInformation;
